import { Themes } from "../utils/constant";

import ClassicElegance from "../main-component/ClassicElegance/ClassicElegance";
import ModernChic from "../main-component/ModernChic";
import IndianTouch from "../main-component/IndianTouch";
import EternalGrace from "../main-component/EternalGrace";
import RegalMuse from "../main-component/RegalMuse";
import TimelessCharm from "../main-component/TimelessCharm";
import RoyalMahal from "../main-component/RoyalMahal";
import Utsav from "../main-component/Utsav";

import { ClassicEleganceData } from "../json/classicElegance";
import { ModernChicData } from "../json/modernChic";
import { EternalGraceData } from "../json/eternalGrace";
import { timelessCharmData } from "../json/timelessCharm";

import RoyalLoader from "../components/RoyalMahal/RoyalLoader";

import DEFAULT_MUSIC from "../music/sound.mp3";
import ROYAL_MAHAL_MUSIC from "../music/royal-mahal.mp3";
// import RANG_UTSAV_MUSIC from "../music/rang-utsav.mp3";
import RANG_UTSAV_MUSIC from "../music/din-shagna-da.mp3";

/*
 * Everything the invitation shell (InvitationWrapper) does differently per theme, in
 * one place. To add a theme, add its identifier to `Themes` (utils/constant.js) and an
 * entry below; leave out any setting the theme doesn't change.
 *
 *   Page          the invitation itself. It receives `onOpenInvite`.
 *   previewData   the sample invite shown at /preview?theme=<identifier>
 *   music         the background song, started when the invite opens
 *   southIndianMusic  the song played instead when the invite is a South Indian wedding
 *                 (its `isSouthIndian` flag); without it, `music` is played for every invite
 *   Loader        shown while the invite loads: the flying bird on parchment
 *                 (RoyalLoader) for every theme. A link's theme is remembered after its
 *                 first visit, so a theme could still be given a loader of its own here.
 *   opensItself   true when the theme draws its own opening (e.g. Royal Mahal's palace
 *                 gate, Rang Utsav's haveli gate) and calls `onOpenInvite` itself. Otherwise the shared envelope is
 *                 shown first and opens the invite.
 *   heartBubbles  the floating hearts drifting over the page once it opens
 */
const DEFAULT_THEME = {
  Page: TimelessCharm,
  previewData: ClassicEleganceData,
  music: DEFAULT_MUSIC,
  Loader: RoyalLoader,
  opensItself: false,
  heartBubbles: true,
};

const THEMES = {
  [Themes.classicElegance]: {
    Page: ClassicElegance,
    previewData: ClassicEleganceData,
  },
  [Themes.modernChic]: {
    Page: ModernChic,
    previewData: ModernChicData,
  },
  [Themes.indianTouch]: {
    Page: IndianTouch,
  },
  [Themes.eternalGrace]: {
    Page: EternalGrace,
    previewData: EternalGraceData,
  },
  [Themes.regalMuse]: {
    Page: RegalMuse,
  },
  [Themes.timelessCharm]: {
    Page: TimelessCharm,
    previewData: timelessCharmData,
  },
  [Themes.royalMahal]: {
    Page: RoyalMahal,
    music: ROYAL_MAHAL_MUSIC,
    opensItself: true,
    heartBubbles: false,
  },
  [Themes.utsav]: {
    Page: Utsav,
    music: RANG_UTSAV_MUSIC,
    southIndianMusic: DEFAULT_MUSIC, // sound.mp3
    opensItself: true,
    heartBubbles: false,
  },
};

/**
 * The settings for a theme identifier. An unknown or missing identifier (e.g. before
 * the invite has loaded) gets the defaults.
 */
export const getThemeConfig = (identifier) => ({
  ...DEFAULT_THEME,
  ...(THEMES[identifier] || {}),
  identifier,
});
